export const employee_about = [
    {
        key: "JohDee",
        firstName: "John (Deemer)",
        lastName: "Deem",
        title: "Owner & Founder",
        img: "/employees/Jdeem.jpeg",
        year: "1998",
        dept: "Management"
    },
    {
        key: "BenEng",
        firstName: "Ben",
        lastName: "Engwall",
        title: "Managing Director",
        img: "/employees/Bengwall.jpeg",
        year: "2015",
        dept: "Management"
    },
    {
        key: "KriHod",
        firstName: "Kris",
        lastName: "Hodgkins",
        title: "General Manager",
        img: "/employees/Khodgkins.jpg",
        year: "2014",
        dept: "Management"
    },
    {
        key: "EriGon",
        firstName: "Erica",
        lastName: "Gonzalez",
        title: "Bookkeeper",
        img: "/employees/Egonzalez.jpg",
        year: "2014",
        dept: "Admin"
    },
    {
        key: "JerTif",
        firstName: "Jeremy",
        lastName: "Tiffany",
        title: "Senior System Support Engineer",
        img: "/employees/Jtiffany.jpg",
        year: "1999",
        dept: "Technician"
    },
    {
        key: "BreWri",
        firstName: "Brett",
        lastName: "Wright",
        title: "System Support Engineer",
        img: "/employees/Bwright.jpeg",
        year: "2016",
        dept: "Technician"
    },
    {
        key: "DonLuc",
        firstName: "Donnie",
        lastName: "Lucker",
        title: "Lead Technician",
        img: "/employees/Dlucker.jpg",
        year: "2009",
        dept: "Technician"
    },
    {
        key: "TimKea",
        firstName: "Tim",
        lastName: "Keate",
        title: "Lead Technician",
        img: "/employees/TKeate.jpg",
        year: "2022",
        dept: "Technician"
    },
    {
        key: "ScoDei",
        firstName: "Scott",
        lastName: "Dietze",
        title: "Sales & Project Mgmt.",
        img: "/employees/Sdeitze.jpg",
        year: "2022",
        dept: "Sales"
    },
    {
        key: "KeiPar",
        firstName: "Keith",
        lastName: "Parker",
        title: "Sales & Project Mgmt.",
        img: "/employees/KeiPar.jpeg",
        year: "2022",
        dept: "Sales"
    },
    {
        key: "CurEle",
        firstName: "Curtis",
        lastName: "Elethorp",
        title: "Customer Support Specialist",
        img: "/employees/Celethorp.jpg",
        year: "2019",
        dept: "Admin"
    },
    {
        key: "CamBis",
        firstName: "Cam",
        lastName: "(Jamz) Bishop",
        title: "Lead Technician",
        img: "/employees/Cbishop.jpg",
        year: "2019",
        dept: "Technician"
    },
    {
        key: "LiaZhe",
        firstName: "Liam",
        lastName: "Zhe",
        title: "Service Technician",
        img: "/employees/Lzhe.jpg",
        year: "2021",
        dept: "Technician"
    },
    {
        key: "NoaMan",
        firstName: "Noah",
        lastName: "Mangeri",
        title: "Installation Technician",
        img: "/employees/Nmangeri.jpg",
        year: "2023",
        dept: "Technician"
    },
    {
        key: "CodSha",
        firstName: "Cody",
        lastName: "Sharkey",
        title: "Installation Technician",
        img: "/employees/Csharkey.jpeg",
        year: "2019",
        dept: "Technician"
    },
    {
        key: "JasKra",
        firstName: "Jason",
        lastName: "Kraabel",
        title: "Installation Technician",
        img: "/employees/Jkraabel.jpg",
        year: "2023",
        dept: "Technician"
    },
]


// Here is the formatting to add a new employee to the page: 
// {
//     key: "",
//     firstName: "",
//     lastName: "",
//     title: "",
//     img: "/employees/[first initial][last name].jpg", **(foot note)
//     year: "",
//     dept: ""
// }

// ** Footnote:
// you will need to add a JPEG img to the "client/public/employees" directory of this code base
// in order to have the image show up on the page, before making any changes. 
// I recommend following the template suggestion given above.
 
// copy and paste the information in the template above and remove the "//" comment marks. 
// fill out the information within the quotation marks per the new employee.
// link the proper photo, then save, compile, and deploy. 

// at some point i will create a database and API endpoint in order to do this more effectively but in the mean time, this works. 
